import React, { forwardRef } from 'react'

import MaterialTable from '@material-table/core'
import objectPath from 'object-path'

import AddBox from '@material-ui/icons/AddBox'
import ArrowDownward from '@material-ui/icons/ArrowDownward'
import Check from '@material-ui/icons/Check'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import ChevronRight from '@material-ui/icons/ChevronRight'
import Clear from '@material-ui/icons/Clear'
import DeleteOutline from '@material-ui/icons/DeleteOutline'
import Edit from '@material-ui/icons/Edit'
import FilterList from '@material-ui/icons/FilterList'
import FirstPage from '@material-ui/icons/FirstPage'
import LastPage from '@material-ui/icons/LastPage'
import Remove from '@material-ui/icons/Remove'
import SaveAlt from '@material-ui/icons/SaveAlt'
import Search from '@material-ui/icons/Search'
import ViewColumn from '@material-ui/icons/ViewColumn'

const tableIcons = {
  Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
  Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
  Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
  DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
  Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
  Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
  FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
  LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
  NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
  PreviousPage: forwardRef((props, ref) => (
    <ChevronLeft {...props} ref={ref} />
  )),
  ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
  Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
  SortArrow: forwardRef((props, ref) => (
    <ArrowDownward {...props} ref={ref} />
  )),
  ThirdStateCheck: forwardRef((props, ref) => (
    <Remove {...props} ref={ref} />
  )),
  ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />),
}

const Table = (props) => {
  const { selectRowOnTabAction, ...tableProps } = props
  const isSelectRowOnTab = !!selectRowOnTabAction

  const handleSelectRowOnTab = (event) => {
    if (!isSelectRowOnTab) return
    if (event.type === 'click') return

    const target = event.target
    const isActionClick =
      target?.closest?.('button') ||
      target?.closest?.('a') ||
      target?.closest?.('input')

    if (isActionClick) return

    const rowElement = target?.closest?.('tr[index]')
    const rowIndex = rowElement?.getAttribute?.('index')
    if (rowIndex === undefined || rowIndex === null) return

    const rowData = objectPath.get(tableProps, ['data', Number(rowIndex)])
    if (!rowData) return

    if (selectRowOnTabAction.isClickButton) {
      selectRowOnTabAction.setIsClickButton &&
        selectRowOnTabAction.setIsClickButton(false)
    } else {
      selectRowOnTabAction.getAction && selectRowOnTabAction.getAction(rowData)
    }
  }

  return (
    <div
      onMouseDownCapture={handleSelectRowOnTab}
      onClickCapture={handleSelectRowOnTab}
    >
      <MaterialTable
        icons={{ ...tableIcons, ...tableProps.tableIcons }}
        {...tableProps}
      />
    </div>
  )
}

export default Table
